import apiClient from './client';

/**
 * Auth API Client Layer
 * Encapsulates all backend operations for Mission 11 User Authentication & Session.
 */

export const register = async ({ email, password, displayName }) => {
  const payload = {
    email: email.trim(),
    password,
    display_name: displayName ? displayName.trim() : undefined
  };
  const response = await apiClient.post('/auth/register', payload);
  return response.data;
};

export const login = async ({ email, password }) => {
  const payload = {
    email: email.trim(),
    password
  };
  const response = await apiClient.post('/auth/login', payload);
  return response.data;
};

export const logout = async () => {
  const response = await apiClient.post('/auth/logout');
  return response.data;
};

export const getCurrentUser = async () => {
  const response = await apiClient.get('/auth/me');
  return response.data;
};
